import { Dropdown } from "primereact/dropdown";
import { useState } from "react";
import { ChartArea } from "../../../charts/chartArea";
import { ChartPanel } from "../../../charts/chartPanel";
import { DocFormatAnalytics } from "./docFormatAnalytics";
import { DocsUploadedAnalytics } from "./docsUploadedAnalytics";
import ResetData from "../../../controls/resetData";
import { CategorySelecterDropdown } from "../../../controls/categoryDropdown";

const _props = {
  dataListTemplate: "",
  chartConfig: {},
};

export function DocumentAnalyticsInfo(props = _props) {
  const leftChartConfig = [...props.chartConfig.charts.leftW].sort(
    (a, b) => a.sequence - b.sequence
  ).filter(obj => obj.active === true);
  const rightChartConfig = [...props.chartConfig.charts.rightW].sort(
    (a, b) => a.sequence - b.sequence
  ).filter(obj => obj.active === true);

  const [leftGraph, setLeftGraph] = useState(leftChartConfig[0]);
  const [rightGraph, setRightGraph] = useState(rightChartConfig[0]);

  const [leftReset, setLeftReset] = useState(false);
  const [rightReset, setRightReset] = useState(false);

  return (
    <ChartPanel
      left={
        <ChartArea
          key={leftGraph.name}
          title={leftGraph.title}
          categorySwitch={
            <CategorySelecterDropdown
              setCategory={setLeftGraph}
              categoryOptions={leftChartConfig}
              selectedCategory={leftGraph}
            />
          }
          chartConfig={leftGraph}
          resetData={<ResetData reset={leftReset} setReset={setLeftReset} dataTemplate={props.dataListTemplate} />}
          renderWithPeriod={(period) => {
            return (
              <DocsUploadedAnalytics
                graphConfig={leftGraph}
                period={period}
                dataListTemplate={props.dataListTemplate}
                setReset={setLeftReset}
              />
            );
          }}
        ></ChartArea>
      }
      
      right={
        <ChartArea
          key={rightGraph.name}
          title={rightGraph.title}
          categorySwitch={
            <CategorySelecterDropdown
              setCategory={setRightGraph}
              categoryOptions={rightChartConfig}
              selectedCategory={rightGraph}
            />
          }
          chartConfig={rightGraph}
          resetData={<ResetData reset={rightReset} setReset={setRightReset} dataTemplate={props.dataListTemplate} />}
          renderWithPeriod={(period) => {
            return (
              <DocsUploadedAnalytics
                graphConfig={rightGraph}
                period={period}
                dataListTemplate={props.dataListTemplate}
                setReset={setRightReset}
              />
            );
          }}
        ></ChartArea>
      }
    ></ChartPanel>
  );
}
